import { IMapToolbar } from "../../interfaces/IMapToolbar";
import "./toolbarExtension.scss";

export class ToolbarExtension extends Autodesk.Viewing.Extension {
	public static readonly extensionName: string = "Autodesk.ToolbarExtension";
	private readonly ControlAddedEvent: string = "ControlGroup.ControlAdded";

	public constructor(viewer: Autodesk.Viewing.GuiViewer3D, public toolbarOptions: IMapToolbar) {
		super(viewer, toolbarOptions);
	}

	public load(): boolean {
		return true;
	}

	public unload(): boolean {
		return true;
	}

	public onToolbarCreated(toolbar: Autodesk.Viewing.UI.ToolBar): void {
		toolbar.addEventListener(this.ControlAddedEvent, () => this.OnControlLoaded(toolbar));
	}

	private OnControlLoaded(toolbar: Autodesk.Viewing.UI.ToolBar): void {
		// list of Autodesk extensions: https://forge.autodesk.com/en/docs/viewer/v7/reference/Extensions/ViewCubeUi/
		if (!this.toolbarOptions.showHomeButton && this.viewer.isExtensionLoaded("Autodesk.ViewCubeUi")) {
			this.viewer.unloadExtension("Autodesk.ViewCubeUi");
		} else {
			const viewCubeWrapper = document.getElementsByClassName("viewcubeWrapper");
			if (viewCubeWrapper) {
				viewCubeWrapper[0].classList.add("visible");
			}
		}

		this.switchNavToolbarItem(toolbar, this.toolbarOptions.showPanButton, "navTools", "toolbar-panTool");
		this.switchNavToolbarItem(toolbar, this.toolbarOptions.showCameraActionsButton, "navTools", "toolbar-cameraSubmenuTool");
		this.switchNavToolbarItem(toolbar, this.toolbarOptions.showFullScreenToggleButton, "settingsTools", "toolbar-fullscreenTool");

		toolbar.removeEventListener(this.ControlAddedEvent);
	}

	private switchNavToolbarItem(toolbar: Autodesk.Viewing.UI.ToolBar, doShow: boolean, toolbarGroupId: string, toolbarItemElementId: string): void {
		const toolbarGroup = toolbar.getControl(toolbarGroupId) as Autodesk.Viewing.UI.ControlGroup;

		if (!doShow) {
			toolbarGroup.removeControl(toolbarItemElementId);
		} else {
			const control = toolbarGroup.getControl(toolbarItemElementId);
			control.addClass("visible");
		}
	}
}
